import {Button} from "@zendeskgarden/react-buttons";
import {ReactElement} from "react";

import * as css from "./styles/selectionBar.module.scss";
import cn from "classnames";
import {AuthUser} from "../../../contexts/auth_types";
import {userIsAdmin} from "../../../authorization/AuthorizationCheckers";
import {AcquisitionPropertyRentRollButton} from "./AcquisitionPropertyRentRollButton";
import { AcquisitionPropertyMRSButton } from "./AcquisitionPropertyMRSButton";

export interface ISelectionBar {
    selected: string[];
    onEdit: () => void;
    onDelete: () => void;
    onUploadAccountValues?: () => void;
    onUploadRentRoll?: (jobId: string, propertyId: string) => void;
    onCopyToNormal?: () => void;
    onCopyFromNormal?: () => void;
    name: string;
    namePlural: string;
    enableBulk?: boolean;
    user: AuthUser | null;
}

export default function SelectionBar(props: ISelectionBar): ReactElement {
    return (

        <div className={`${css.userSelectionBar} ${props.selected.length ? css.userSelectionBarVisible : ''}`}>
            <div className={css.userSelectionBarCount}><span>{props.selected.length}</span></div>
            <h4>{props.selected.length == 1 ? props.name : props.namePlural} selected</h4>

            <div className={css.userSelectionBarActions}>
                {/* until bulk editing is ready, hide the edit button for bulk operations */}
                <Button className={`${css.userSelectionButton} ${props.selected.length > 1 && !props.enableBulk ? css.userSelectionButtonHidden : ''}`} onClick={props.onEdit} disabled={props.selected.length > 1 && !props.enableBulk}>
                    {props.selected.length == 1 ? `Edit ${props.name}` : "Bulk Edit"}
                </Button>

                <Button className={css.userSelectionButton} onClick={props.onDelete}>
                    {props.selected.length == 1 ? `Deactivate ${props.name}` : "Bulk Deactivate"}
                </Button>

                {userIsAdmin(props.user) && props.selected.length === 1 && props.onCopyToNormal &&
                    <Button className={css.userSelectionButton} onClick={props.onCopyToNormal}>Copy to Live Budget</Button>
                }

                {userIsAdmin(props.user) && props.selected.length === 1 && props.onCopyFromNormal &&
                    <Button className={css.userSelectionButton} onClick={props.onCopyFromNormal}>Import Modeling Methods</Button>
                }

                {props.selected.length === 1 && props.selected[0] && props.onUploadRentRoll &&
                    <AcquisitionPropertyRentRollButton propertyId={props.selected[0]} jobCreated={props.onUploadRentRoll}/>
                }

                {props.selected.length === 1 && props.selected[0] && props.onUploadRentRoll &&
                    <AcquisitionPropertyMRSButton propertyId={props.selected[0]} jobCreated={props.onUploadRentRoll}/>
                }

                {props.selected.length === 1 && props.onUploadAccountValues &&
                    <Button className={cn(css.userSelectionButton)} onClick={props.onUploadAccountValues}>Update Account Values</Button>
                }
            </div>
        </div>
    );
}
